export var ALIASES_TO_SIZES = {
  small: 16,
  medium: 20,
  large: 24
};
export var DEFAULT_ICON_ALIAS = 'small';
export var DEFAULT_ICON_SIZE = 16;